import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../html/element'
import { Icon } from '../../../../../html/icon'
import { SelectCustom } from '../../../../../selectCustom'
import { SCROLL_COMPONENT_IDS } from '../../../../constant'
import {
  TYPE_LOGICAL_OPERATOR,
  changeLogicalOperator,
  changeTypeScoreBottom,
  selectTypeScoreBottom,
} from '../../../../store/sliceScoreLevel'
import { TYPE_SCORE } from '../../../constant'
import classes from '../scoreLevel.module.scss'
import { TextHover } from './TextHover'

export const AndOrButton = ({ typeLogical, clearDataBottomWhenHidden }) => {
  const dispatch = useDispatch()

  const typSoreBottom = useSelector(selectTypeScoreBottom)

  //Actions
  const handleSelectTypeScore = (value) => {
    dispatch(changeTypeScoreBottom(value))
  }
  const handelAnd = () => {
    dispatch(changeLogicalOperator(TYPE_LOGICAL_OPERATOR.AND))
  }
  const handelOr = () => {
    dispatch(changeLogicalOperator(TYPE_LOGICAL_OPERATOR.OR))
  }
  const handleRemoveLogical = () => {
    dispatch(changeLogicalOperator(TYPE_LOGICAL_OPERATOR.NOT))
    clearDataBottomWhenHidden && clearDataBottomWhenHidden()
  }

  return (
    <Element className={classes.AndOr}>
      {typeLogical.value === TYPE_LOGICAL_OPERATOR.NOT.value && (
        <div className="dFlex alignItemsCenter ">
          <Icon
            className="icon-plus-circle-fill"
            style={{
              color: '#2C73E8',
              fontSize: 15,
              paddingRight: 4,
              cursor: 'auto',
            }}
          />
          <TextHover text="library.filterSetting.AND" onClick={handelAnd} />
          <Element elementName="span">&nbsp;/&nbsp;</Element>
          <TextHover text="library.filterSetting.OR" onClick={handelOr} />
        </div>
      )}

      {typeLogical.value !== TYPE_LOGICAL_OPERATOR.NOT.value && (
        <>
          <div className="dFlex alignItemsCenter gap1 fw600">
            <Translate
              value={
                typeLogical.value === TYPE_LOGICAL_OPERATOR.AND.value
                  ? 'library.filterSetting.AND'
                  : 'library.filterSetting.OR'
              }
              style={{ color: '#2C73E8' }}
            />
            <SelectCustom
              activeItem={typSoreBottom}
              data={TYPE_SCORE}
              style={{
                width: 220,
                minHeight: 28,
                fontWeight: 600,
                color: '#3A414B',
              }}
              isI18n
              chooseItem={handleSelectTypeScore}
              scrollId={SCROLL_COMPONENT_IDS}
            />
          </div>
          <div>
            <Icon
              style={{ color: '#9C9C9C', fontSize: 16 }}
              className="icon-trash-fill"
              onClick={handleRemoveLogical}
            />
          </div>
        </>
      )}
    </Element>
  )
}
